import $ from 'jquery';

class Vdc {
    constructor() {
        this.orderForm = $('.gf-vdc');

        if (!this.orderForm.length) return;

        this.submitBtn = this.orderForm.find('.gform_page_footer input[type=button]');
        this.events();
    }

    events() {
        gform.addAction('gform_input_change', this.minPropsLogic.bind(this));
    }

    minPropsLogic() {

        const ssdVolume = +this.orderForm.find('.gf-vdc__qty--ssd input').val();
        const hddVolume = +this.orderForm.find('.gf-vdc__qty--hdd input').val();

        const cpuVolume = +this.orderForm.find('.gf-vdc__qty--vcpu input').val();
        const cpuAdvancedVolume = +this.orderForm.find('.gf-vdc__qty--vcpu-adv input').val();

        const cpuNotice = this.orderForm.find('.gf-vdc__notice--cpu');
        const storageNotice = this.orderForm.find('.gf-vdc__notice--storage');

        const isMinStorage = ssdVolume + hddVolume < 200;
        const isMinCpu = cpuVolume + cpuAdvancedVolume < 8;

        this.showNotice(isMinStorage, storageNotice)
        this.showNotice(isMinCpu, cpuNotice)

        if(isMinStorage || isMinCpu) {
            this.submitBtn.attr('disabled', 'disabled');
        } else {
            this.submitBtn.removeAttr('disabled');
        }
    }

    showNotice(isMinProp, noticeEl)
    {
        if(isMinProp) {
            noticeEl.fadeIn();
        } else {
            noticeEl.fadeOut();
        }
    }
}

export default Vdc;
